module.exports = __webpack_public_path__ + "static/assets/18ae27e79fd3e75208135c8c71482987.otf";